import React from "react";
import { Switch, Route } from "react-router-dom";
import { retry } from "utils/lazy";

import { slugs } from "utils/partners";

const ForgotPassword = React.lazy(() =>
  retry(() => import("modules/auth/pages/forgotPassword"))
);
const Code = React.lazy(() => retry(() => import("modules/auth/pages/code")));
const NewPassword = React.lazy(() =>
  retry(() => import("modules/auth/pages/newPassword"))
);
const NotFound = React.lazy(() => retry(() => import("templates/NotFound")));
const WrapperPage = React.lazy(() =>
  retry(() => import("modules/auth/components/wrapper"))
);
const Datasheet = React.lazy(() =>
  retry(() => import("modules/auth/pages/datasheet"))
);
const ValidateDatasheet = React.lazy(() =>
  retry(() => import("modules/auth/pages/validateDatasheet"))
);
const Login = React.lazy(() => retry(() => import("modules/auth/pages/login")));
const CreateAccount = React.lazy(() =>
  retry(() => import("modules/auth/pages/createAccount"))
);

const AuthRoutes = () => (
  <Switch>
    <Route exact path="/login" component={(props) => <Login {...props} />} />

    <Route
      path="/login/reautenticar"
      component={(props) => <Login {...props} />}
    />

    <Route
      exact
      path={`/criar-conta/:slug(${slugs.join("|")})?`}
      component={(props) => <CreateAccount {...props} />}
    />

    <Route
      exact
      path="/esqueci-minha-senha"
      component={(props) => (
        <WrapperPage>
          <ForgotPassword {...props} />
        </WrapperPage>
      )}
    />
    <Route
      exact
      path="/codigo"
      component={(props) => (
        <WrapperPage>
          <Code {...props} />
        </WrapperPage>
      )}
    />
    <Route
      exact
      path="/redefinir-senha"
      component={(props) => (
        <WrapperPage>
          <NewPassword {...props} />
        </WrapperPage>
      )}
    />
    <Route
      exact
      path="/ficha-cadastral/validar"
      component={(props) => (
        <WrapperPage page="datasheet">
          <ValidateDatasheet {...props} />
        </WrapperPage>
      )}
    />
    <Route
      exact
      path="/ficha-cadastral/:id"
      component={(props) => <Datasheet {...props} />}
    />
    <Route path="/*" component={(props) => <NotFound {...props} external />} />
  </Switch>
);

export default AuthRoutes;
